import {gql, useLazyQuery} from "@apollo/client";

const GET_DATA = gql`
 query Referees($q: String, $sports: [String], $page: Int, $pageSize: Int) {
  referees(q: $q, sports: $sports, page: $page, pageSize: $pageSize) {
    objects {
        id
        fullName
        user{
            email
            mobile
        }
        profileOrganizationsInvited{
            organization{
                id
                name
            }
            status
        }
        rating
    }
    page
    pages
    hasNext
    hasPrev
  }
}
`;

export default function GetReferees(){
    return useLazyQuery(GET_DATA);
};
